import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { StoreAction } from 'store/actions';
import { buildHeaders, buildParams, XmStore } from 'core/services';
import { BroadbandLabels } from './models';

@Injectable()
export class BroadbandLabelApi {
    public static getBroadbandLabels(_xmStore: XmStore, http: HttpClient, info: NutritionLabelRequest, params: ApiParams): Observable<BroadbandLabels | void> {
        return http.post('/v1/nutrition-labels', info, {
            headers: buildHeaders({ apiChannel: ApiChannel.BROADBAND_LABELS }),
            params: buildParams(params)
        }).pipe(
            map((labels: ApiResponse) => BroadbandLabels.create<BroadbandLabels>(labels))
        );
    }
}

ModelBase.persistMapping[StoreAction.GET_BROADBAND_LABELS] = BroadbandLabelApi.getBroadbandLabels;
